// Stories row (#732). First tap (#733): shell, then viewer and data.
(function () {
if (window.faStoriesLoaded) return;
window.faStoriesLoaded = true;
var KEY = 'fa_stories_seen', MAX = 100, D = document, W = window, H = D.documentElement;
var busy = false, owner, scriptP, styleP, styleFailed, dataP, job;
function readSeen() {
  try { var l = JSON.parse(W.localStorage.getItem(KEY)); return Array.isArray(l) ? l : []; } catch (e) { return []; }
}
function save(l) { try { W.localStorage.setItem(KEY, JSON.stringify(l.slice(-MAX))); } catch (e) {} }
function mark(b) {
  b.classList.add('fa-story-circle--seen');
  b.setAttribute('data-fa-story-seen', 'true');
  b.setAttribute('aria-label', b.getAttribute('data-fa-story-name') + ', seen');
}
function markSeen(handle, button) {
  save(readSeen().filter(function (x) { return x !== handle; }).concat(handle)); // newest last, so the cap drops the least recently watched
  if (button) mark(button);
}
function setupArrows(wrap, row) {
  var p = wrap.querySelector('[data-fa-stories-prev]'), n = wrap.querySelector('[data-fa-stories-next]');
  var m = W.matchMedia && W.matchMedia('(min-width: 768px)'), ro;
  if (!p || !n || !m || !W.ResizeObserver) return;
  function update() {
    var a = D.activeElement, fit = row.scrollWidth <= row.clientWidth + 1;
    if (fit && (a === p || a === n)) row.querySelector('[data-fa-story-open]').focus(); // the arrows are about to hide
    p.hidden = n.hidden = fit;
    p.disabled = row.scrollLeft <= 0;
    n.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
    if (a === p && p.disabled && !n.hidden && !n.disabled) n.focus();
    else if (a === n && n.disabled && !p.hidden && !p.disabled) p.focus();
  }
  function by(s) {
    row.scrollBy({ left: s * Math.max(row.clientWidth * 0.8, 80), behavior: W.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  function bind() { // nothing runs on phones; the arrows are display none below 768px
    if (!m.matches || ro) return;
    p.onclick = function () { by(-1); };
    n.onclick = function () { by(1); };
    row.addEventListener('scroll', update, { passive: true });
    (ro = new ResizeObserver(update)).observe(row);
    update();
  }
  bind();
  m.addEventListener('change', bind);
}
W.faStories = {
  push: function (st) { try { W.history.pushState(st, ''); } catch (e) {} },
  back: function (key) {
    if (!W.history.state || !W.history.state[key]) return;
    busy = true;
    W.history.back();
    setTimeout(function () { busy = false; }, 600);
  },
  own: function (fn) { owner = fn; },
  markSeen: markSeen
};
W.addEventListener('popstate', function (e) { if (busy) busy = false; else if (owner) owner(e); });
function load(el) { return new Promise(function (ok, bad) { el.onload = ok; el.onerror = bad; D.head.appendChild(el); }); }
// The script is asked for once and kept while it loads: a failed stylesheet must not drop a script that is still on its way.
// After the stylesheet failed once, Retry waits for the script only; the viewer asks for the stylesheet again itself and opens unstyled if it still fails.
function fetchAssets(sec) {
  if (W.faStoryViewer) return Promise.resolve();
  if (!scriptP) {
    var j = D.createElement('script');
    j.src = sec.getAttribute('data-fa-viewer-js');
    scriptP = load(j).catch(function (e) { scriptP = null; j.remove(); throw e; });
  }
  if (!styleP && !styleFailed) {
    var l = D.createElement('link');
    l.rel = 'stylesheet';
    l.href = sec.getAttribute('data-fa-viewer-css');
    styleP = load(l).catch(function (e) { styleP = null; styleFailed = true; throw e; });
  }
  return styleFailed ? scriptP : Promise.all([styleP, scriptP]);
}
function fetchData() {
  return dataP || (dataP = W.fetch((((W.Shopify || {}).routes || {}).root || '/') + '?section_id=fa-stories-data')
    .then(function (r) { if (!r.ok) throw 0; return r.text(); })
    .then(function (t) { return JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1)); })
    .catch(function (e) { dataP = null; throw e; }));
}
function begin(handle, button) {
  var sec = button.closest('[data-fa-stories]'), tpl = sec && sec.querySelector('template[data-fa-story-shell-tpl]');
  if (!tpl || job || (W.faStoryViewer && W.faStoryViewer.isOpen())) return;
  if (busy) { setTimeout(function () { begin(handle, button); }, 60); return; }
  shell(job = { handle: handle, button: button, sec: sec }, tpl);
}
function shell(me, tpl) {
  var d = me.dialog = tpl.content.firstElementChild.cloneNode(true), img = me.button.querySelector('img'), x, u = img && (img.currentSrc || img.src || img.getAttribute('data-src'));
  d.setAttribute('aria-label', me.button.getAttribute('data-fa-story-name'));
  if (u) d.firstElementChild.src = u; else d.firstElementChild.remove();
  D.body.appendChild(d);
  x = d.querySelector('.fa-story-shell__close');
  x.onclick = function () { shut(me, true); };
  (me.retry = d.querySelector('.fa-story-shell__retry')).onclick = function () { run(me); };
  d.oncancel = function (e) { e.preventDefault(); shut(me, true); };
  H.classList.add('fa-story-lock');
  W.faStories.push({ faStoryLoad: 1 });
  owner = function (e) { if (!(e.state || {}).faStoryLoad) shut(me, false); };
  if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  x.focus();
  run(me);
}
function run(me) {
  me.dialog.removeAttribute('data-err');
  clearTimeout(me.timer);
  me.timer = setTimeout(function () { fail(me); }, 10000);
  Promise.all([fetchData(), fetchAssets(me.sec)]).then(function (r) { if (!me.dead) give(me, r[0]); }, function () { fail(me); });
}
function fail(me) {
  if (me.dead) return;
  clearTimeout(me.timer);
  me.dialog.setAttribute('data-err', '');
  me.retry.focus();
}
function end(me) {
  me.dead = true;
  clearTimeout(me.timer);
  job = owner = null;
  if (me.dialog.close) me.dialog.close();
  me.dialog.remove();
}
function shut(me, dropEntry) {
  var b = me.button;
  if (me.dead) return;
  end(me);
  H.classList.remove('fa-story-lock');
  if (dropEntry) W.faStories.back('faStoryLoad');
  b.focus();
  setTimeout(function () { b.focus(); }, 0);
}
function give(me, d) {
  var e = d && d[me.handle];
  if (!e || !e.s || !e.s.length || !W.faStoryViewer) { shut(me, true); return; }
  end(me);
  W.faStoryViewer.open(me.handle, me.button, d);
}
function init(row) {
  var seen = readSeen(), wrap = row.closest('.fa-stories__wrap');
  if (row.getAttribute('data-fa-stories-ready')) return;
  row.setAttribute('data-fa-stories-ready', 'true');
  [].forEach.call(row.querySelectorAll('[data-fa-story-open]'), function (b) {
    if (seen.indexOf(b.getAttribute('data-fa-story-handle')) >= 0) mark(b);
  });
  row.addEventListener('click', function (event) {
    var b = event.target.closest('[data-fa-story-open]'), h = b && b.getAttribute('data-fa-story-handle');
    if (!b) return;
    markSeen(h, b);
    row.dispatchEvent(new CustomEvent('fa-stories:open', { bubbles: true, detail: { handle: h, button: b } }));
    begin(h, b);
  });
  if (wrap) setupArrows(wrap, row);
}
function initAll(root) { [].forEach.call(root.querySelectorAll('[data-fa-stories-row]'), init); }
function setCover(i) {
  var set = i.getAttribute('data-srcset');
  if (!i.getAttribute('data-src')) return;
  if (set) i.srcset = set;
  i.src = i.getAttribute('data-src');
  i.removeAttribute('data-src');
}
function setCovers() { // only the row's own covers (#842), and only those near the visible part of the row (#848)
  var all = D.querySelectorAll('[data-fa-stories] .fa-story-circle__img[data-src]');
  [].forEach.call(all, function (i) {
    var row = i.closest('[data-fa-stories-row]');
    if (!row || !W.IntersectionObserver) { setCover(i); return; }
    var io = row.faIo || (row.faIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); setCover(e.target); } });
    }, { root: row, rootMargin: '0px 80px' })); // about one circle either side, so a scroll finds the next cover ready
    io.observe(i);
  });
}
var ban = [].filter.call(D.querySelectorAll('.yv-banner-container img[fetchpriority="high"]'), function (i) { return i.offsetWidth; })[0];
setTimeout(setCovers, 8000);
W.addEventListener('load', setCovers);
if (ban && ban.complete) setCovers(); else if (ban) ['load', 'error'].forEach(function (e) { ban.addEventListener(e, setCovers); });
initAll(D);
D.addEventListener('shopify:section:load', function (e) { initAll(e.target); setCovers(); });
})();
